import Vue from 'vue'
import VueRouter from 'vue-router'
import Intro from '../views/Intro.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'intro',
    component: Intro
  },
  {
    path: '/story',
    name: 'story',
    component: () => import(/* webpackChunkName: "story" */ '../views/Story.vue')
  },
  {
    path: '/backend',
    name: 'backend',
    component: () => import(/* webpackChunkName: "backend" */ '../views/Backend.vue')
  },
  {
    path: '/api',
    name: 'api',
    component: () => import(/* webpackChunkName: "api" */ '../views/Api.vue')
  },
  {
    path: '/backend-java',
    name: 'backend-java',
    component: () => import(/* webpackChunkName: "backend-java" */ '../views/BackendJava.vue')
  },
  {
    path: '/backend-java-deploy',
    name: 'backend-java-deploy',
    component: () => import(/* webpackChunkName: "backend-java-deploy" */ '../views/BackendJavaDeploy.vue')
  },
  {
    path: '/backend-dot-net',
    name: 'backend-dot-net',
    component: () => import(/* webpackChunkName: "unsupported" */ '../views/Unsupported.vue')
  },
  {
    path: '/frontend',
    name: 'frontend',
    component: () => import(/* webpackChunkName: "frontend" */ '../views/Frontend.vue')
  },
  {
    path: '/frontend-vue',
    name: 'frontend-vue',
    component: () => import(/* webpackChunkName: "frontendvue" */ '../views/FrontendVue.vue')
  },
  {
    path: '/frontend-react',
    name: 'frontend-react',
    component: () => import(/* webpackChunkName: "frontendreact" */ '../views/FrontendReact.vue')
  },
  {
    path: '/frontend-angular',
    name: 'frontend-angular',
    component: () => import(/* webpackChunkName: "frontendangular" */ '../views/FrontendAngular.vue')
  },
  {
    path: '/verify',
    name: 'verify',
    component: () => import(/* webpackChunkName: "verify" */ '../views/Verify.vue')
  },
  {
    path: '/backend-deploy',
    name: 'backend-deploy',
    component: () => import(/* webpackChunkName: "unsupported" */ '../views/Unsupported.vue')
  },
  {
    path: '/frontend-serverless',
    name: 'frontend-serverless',
    component: () => import(/* webpackChunkName: "feserverless" */ '../views/FrontendServerless.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "unsupported" */ '../views/Unsupported.vue')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "unsupported" */ '../views/Unsupported.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
